import React from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import "../css/LocalTendersPage.css";

const LocalTendersPage = () => {
  return (
    <>
      <Header />
      <div className="local-tenders-page">
        {/* Banner image */}
        <div
          className="local-tenders-banner"
          style={{
            backgroundImage:
              "url('/wp-content/uploads/2020/12/Cable-Laying-and-Repair-Vessel-for-Orange-Marine-to-be-built-by-Colombo-Dockyard.png')",
          }}
        ></div>

        <div className="local-tenders-content">
          {/* Breadcrumb */}
          <div className="local-tenders-breadcrumb">
            <Link to="/">Home</Link> &gt;{" "}
            <span className="current">Local Tenders</span>
          </div>

          <h1 className="local-tenders-title">Local Tenders</h1>

          <div className="local-tenders-description">
            <p>
              eSupplier web portal for submission of e-tenders, registration of
              suppliers, submission of registration applications.
            </p>
          </div>

          <div className="local-tenders-button-wrapper">
            <a
              href="https://esupplier.cdl.lk/"
              className="local-tenders-button"
              target="_blank"
              rel="noopener noreferrer"
            >
              Local Tenders
            </a>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default LocalTendersPage;
